import { Link } from 'react-router-dom';
import { comicArticles } from '@/mocks/comics';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20Korean%20manhwa%20comic%20panels%20collage%20with%20dynamic%20action%20scenes%20and%20romantic%20moments%2C%20vibrant%20warm%20color%20palette%20with%20coral%20red%20and%20golden%20amber%20accents%2C%20dramatic%20lighting%2C%20abstract%20artistic%20composition%2C%20modern%20graphic%20design%2C%20no%20text%2C%20digital%20art%20style&width=1920&height=800&seq=manhwa-hero-bg&orientation=landscape"
        alt="韩漫在线阅读"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <p className="text-accent-300 text-sm md:text-base font-medium mb-3 tracking-wider">
              韩国漫画 · 在线阅读 · 每日更新
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              发现你的<span className="text-accent-300">下一部</span>最爱韩漫
            </h1>
            <p className="text-background-50/80 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
              海量韩国漫画免费在线阅读，涵盖恋爱、奇幻、动作、悬疑等热门类型。每日更新，让你沉浸在精彩的漫画世界中。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to="/category/romance"
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-bold rounded-full transition-all duration-300 whitespace-nowrap text-sm shadow-lg shadow-primary-500/25"
              >
                开始阅读
              </Link>
              <Link
                to="/category/completed"
                className="px-6 py-3 bg-background-50/15 backdrop-blur-sm hover:bg-background-50/25 text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap text-sm border border-background-50/20"
              >
                完结推荐
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8">
              <div className="flex items-center gap-2">
                <span className="text-accent-300 font-heading font-bold text-2xl md:text-3xl">{comicArticles.length}+</span>
                <span className="text-background-50/70 text-xs">部精选漫画</span>
              </div>
              <div className="w-px h-8 bg-background-50/20" />
              <div className="flex items-center gap-2">
                <span className="text-accent-300 font-heading font-bold text-2xl md:text-3xl">8</span>
                <span className="text-background-50/70 text-xs">大分类</span>
              </div>
              <div className="w-px h-8 bg-background-50/20" />
              <div className="flex items-center gap-2">
                <span className="text-accent-300 font-heading font-bold text-2xl md:text-3xl">100万+</span>
                <span className="text-background-50/70 text-xs">读者选择</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-background-50/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}